import {Typography} from "@leap4/frontend";
import {renderValue} from "../renderValues";
import React from "react";


interface ISingleMetricProps{
    metricValue:number,
    metricEnum:string
}
export const SingleMetric = ({metricValue, metricEnum}: ISingleMetricProps) => {
    return (
    <>
        <Typography variant="button" component="h6" style={{fontWeight: 700}}>
            {metricEnum.toUpperCase()}
        </Typography>
        {renderValue(metricValue || 0, metricEnum)}
    </>
)}